<template>
  <table class="" style="width: 100%" :style="cssProps">
    <template v-if="topDocument.publication === 'internal'">
      <internal-author-top v-model="author"></internal-author-top>
    </template>
    <tr v-else :class="{selected: author.selected}">
      <td class="col-md-2 col-xs-2 expertColor" style="vertical-align: middle" id="expert">
        {{ author.lastName }}, {{ author.firstName }}
      </td>

      <td class="col-md-3 col-xs-3 " style="vertical-align: middle" id="country-affiliation">
        <table class="table expertColor" style="width: 100%;">
          <td class="col-xs-4 col-md-4 text-center" style="vertical-align: middle">
            <flag v-if="author.affiliation && author.affiliation.organisationID" :squared="false" :iso="getIso(author.affiliation)" style="height: 100%"/>
          </td>
          <td class="col-xs-8 col-md-8" v-if="author.affiliation && author.affiliation.organisationID" style="">{{author.affiliation.organisationName | truncate(50)}}</td>
        </table>
      </td>

      <td v-if="hasInternalDocument === true" class="col-md-4 col-xs-4 expertColor" id="top-document-title" style="">Edison application extract + internal document(s)</td>
      <td v-else class="col-md-4 col-xs-4 expertColor" id="top-document-title" style="">Edison application extract</td>

      <td class="col-md-1 col-xs-1 text-center se" id="expert-score" style="vertical-align: center">
        <select :id="'score-'+ author.authorID">
          <option value="3">3</option>
          <option value="2">2</option>
          <option value="1">1</option>
        </select>
      </td>
      <td class="col-md-1 col-xs-1 text-center" style="vertical-align: middle;" ref="actions">
        <i v-if="author.followSearchId !== null" class="fas fa-star text-info"></i>
        <span class="label label-info" v-if="hasNewDocument === true">New</span>
        <img v-if="topDocument.publication !== 'internal'" style="height: 20px;vertical-align: top" src="../../assets/images/EDISON-100px.png" data-toggle="popover" :data-content="'Edison expert'">
        <i class="fa fa-file-archive-o expertColor" style="font-size: 20px" v-if="hasInternalDocument === true" data-toggle="popover" :data-content="'internal document'"></i>
      </td>
      <td class="col-md-1 col-sm-1 text-center " style="vertical-align: center" id="expert-action">
        <div class="">
          <a :href="topDocument.link" target="_blank" class="btn btn btn-xs btn-success">
            <template v-if="!$user.isBasic()">Contact</template>
            <template v-else> Contact ...</template>
          </a>
        </div>
      </td>
    </tr>
  </table>

</template>

<style scoped>
.expertColor {
  color: var(--expert-color);
}

.selected {
  border-left: 5px solid #3498db;
}

.dropdown-menu {
  min-width: 50px;
}
div > .dropdown > i {
  cursor: pointer;
}

.dropdown-expert-action > ul > li i{
  font-weight: bold;
  margin-right: 5px;
}

.dropdown-expert-action ul > li a{
  font-size: 12px;
}

.dropdown-expert-action ul > li{
  margin-bottom: 5px;
  font-size: 12px;
}

</style>
<style>
.se .br-theme-bars-horizontal .br-widget a {
  height: 10px;
  background-color: var(--rating-color);
  /*background-color: rgba(0, 123, 225, 0.3);*/

}

.se .br-theme-bars-horizontal .br-widget a.br-active, .se .br-theme-bars-horizontal .br-widget a.br-selected {
  background-color: var(--expert-color);
}
</style>

<script>
import 'jquery-bar-rating/dist/jquery.barrating.min'
import IsoCountries from 'i18n-iso-countries'
import EnCountries from '../../iconFlag/en'
import 'jquery-bar-rating/dist/themes/bars-horizontal.css'
import {convertHex} from '../../assets/scripts/utils'
import InternalAuthorTop from './InternalAuthorTop'

IsoCountries.registerLocale(EnCountries)

export default {
  components: {InternalAuthorTop},
  name: 'AuthorSETop',
  props: ['value', 'context'],
  data () {
    return {
      author: null,
      topDocument: null,
      expertColor: '#6a6c6f',
      ratingColor: '#007bff',
      hasNewDocument: false,
      hasInternalDocument: false
    }
  },
  watch: {
    value: function (val) {
      this.author = val
      this.getAdditionalInformation()
    },
    author: function (val, oldVal) {
      if (typeof this.$refs.actions !== 'undefined') {
        $(this.$refs.actions).find('[data-toggle="popover"]').popover({
          trigger: 'hover',
          placement: 'top'
        })
      }

      if (oldVal !== null) {
        this.$emit('input', val)
      }
    }
  },
  computed: {
    cssProps () {
      return {
        '--expert-color': '#' + this.expertColor,
        '--rating-color': convertHex('#' + this.ratingColor, 0.3),
        'z-index': 500
      }
    }
  },
  methods: {
    initScore: (author) => {
      let scoreElement = $('#score-' + author.authorID)

      scoreElement.barrating({
        theme: 'bars-horizontal',
        readonly: true,
        showSelectedRating: false,
        hoverState: false,
        reverse: true,
        initialRating: 0.1
      })
    },
    getIso: (affiliation) => {
      if (typeof affiliation !== 'undefined') {
        let iso = IsoCountries.getAlpha2Code(affiliation.country, 'en')
        if (typeof iso === 'undefined') {
          iso = IsoCountries.toAlpha2(affiliation.code)
        }
        return iso
      }
    },
    getAdditionalInformation: function () {
      if (this.author !== null) {
        this.author.docs.forEach((document) => {
          if (document.newDocument === true) {
            this.hasNewDocument = true
          }
          if (document.publication === 'internal') {
            this.hasInternalDocument = true
          }
        })
      }
    }
  },
  updated () {
    this.topDocument = this.author.docs[0]
    this.initScore(this.author)
  },
  mounted () {
    this.initScore(this.author)
  },
  beforeMount () {
    this.author = this.value
    this.expertColor = this.$auth.user().profile.color_expert
    this.ratingColor = this.expertColor

    if (typeof this.author.topDocument !== 'undefined' && this.author.topDocument !== null) {
      this.topDocument = this.author.topDocument
    } else {
      this.topDocument = this.author.docs[0]
    }
    this.getAdditionalInformation()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/documents/AuthorSETop.vue